import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Aos from 'aos';
import 'bootstrap/scss/bootstrap.scss';
import 'normalize.css';
import './style/index.scss';
import './index.scss';


window.onload = () => {
  Aos.init({
    anchorPlacement: 'center-center',
    mirror: true,
    offset: -500,
  });
}

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.error = () => { };
  console.warn = () => { };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
